import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {Tooltip} from "@mui/material";

import {ReactComponent as EyeIcon} from "assets/img/eye.svg";

OrganizationEshopLink.propTypes = {
    organization: PropTypes.shape({
        eshopUrl: PropTypes.string
    })
};

function OrganizationEshopLink({organization}) {
    if (!organization || !organization.eshopUrl) {
        return null;
    }

    return (
        <Tooltip title={<FormattedMessage id='sidebar.app.externalLinkToEshop' />}>
            <EyeIcon
                onClick={() => window.open(organization.eshopUrl, '_blank')}
                style={{
                    marginLeft: '10px',
                    cursor: 'pointer'
                }}
            />
        </Tooltip>
    );
}

export default OrganizationEshopLink;
